var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDataAva(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No_data_ava",
    "data-name": "No data ava",
    transform: "translate(-3370 -1042)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(3370 1042)",
    fill: "#f8faff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "folder_1_",
    "data-name": "folder (1)",
    transform: "translate(3391.5 1063.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7592",
    "data-name": "Path 7592",
    d: "M34.621,19.457l-.115-6.635a4.338,4.338,0,0,0-4.416-4.258l-.193,0,0-.109A4.338,4.338,0,0,0,25.48,4.2l-6.933.126a.278.278,0,0,1-.208-.088L15.773,1.531A4.353,4.353,0,0,0,12.546.178L4.259.328A4.337,4.337,0,0,0,0,4.743L.438,28.949a4.337,4.337,0,0,0,4.334,4.259h.081l.389-.007L22.3,32.885A9.828,9.828,0,1,0,34.621,19.457ZM4.83,31.921a3.05,3.05,0,0,1-3.106-3L1.286,4.719a3.052,3.052,0,0,1,3-3.106l8.287-.15h.055a3.058,3.058,0,0,1,2.215.953l2.564,2.7a1.568,1.568,0,0,0,1.166.49L25.5,5.485a3.052,3.052,0,0,1,3.106,3l0,.109-16.418.3A4.342,4.342,0,0,0,7.935,13.3l.28,15.505a3.055,3.055,0,0,1-3,3.106ZM8.3,31.856a4.321,4.321,0,0,0,1.2-3.072L9.22,13.279a3.055,3.055,0,0,1,3-3.106l17.9-.324a3.052,3.052,0,0,1,3.107,3l.108,6.225A9.83,9.83,0,0,0,21.795,31.608ZM31.171,37.2a8.542,8.542,0,1,1,8.542-8.542A8.542,8.542,0,0,1,31.171,37.2Zm0,0",
    transform: "translate(0 0)",
    fill: "#0a64f9",
    stroke: "#0a64f9",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7234",
    "data-name": "Group 7234",
    transform: "translate(3422.029 1087.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7593",
    "data-name": "Path 7593",
    d: "M333,258.27a.643.643,0,0,0-.643.643v4.9a.643.643,0,1,0,1.286,0v-4.9A.643.643,0,0,0,333,258.27Zm0,0",
    transform: "translate(-332.359 -258.27)",
    fill: "#e55",
    stroke: "#e55",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7594",
    "data-name": "Path 7594",
    d: "M333,340.7a.643.643,0,0,0-.643.643v.7a.643.643,0,1,0,1.286,0v-.7A.643.643,0,0,0,333,340.7Zm0,0",
    transform: "translate(-332.359 -333.128)",
    fill: "#e55",
    stroke: "#e55",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataAva);
export default __webpack_public_path__ + "static/media/No_data_ava.01906cd3583c5d0eacf6780c2c435d50.svg";
export { ForwardRef as ReactComponent };